// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xRAZ1","image":"styles_image__K0SBM","cards":"styles_cards__yeyJi","card":"styles_card__4pj0e"};